import { useQuery } from "@apollo/client"
import { GET_SEASONS, RANKING_LIST } from "../queries/seasons"
import type { Season, SeasonFilter, PaginationInput } from "../types"
import { SeasonOrderBy } from "../types"

interface SeasonQueryParams extends PaginationInput {
  filter?: SeasonFilter
  orderBy?: SeasonOrderBy
}

export const useSeasons = (params?: SeasonQueryParams) => {
  const { data, loading, error, refetch, fetchMore } = useQuery<{
    allSeasons: Season[]
  }>(GET_SEASONS, {
    variables: {
      filter: params?.filter,
      orderBy: params?.orderBy || "startDate_ASC",
    },
    errorPolicy: "all",
  })

  const loadMore = (page: number) => {
    return fetchMore({
      variables: {
        page,
      },
    })
  }

  return {
    seasons: data?.allSeasons || [],
    loading,
    error,
    refetch,
    loadMore,
  }
}

export const useSeasonsByGame = (gameId: number, limit = 20) => {
  return useSeasons({
    filter: {
      gameId,
      isArchived: 0,
    },
    orderBy: SeasonOrderBy.START_DATE_DESC,
    paginate: limit,
  })
}

export const useRankingList = (rankingListInput) => {
  const { data, loading, error, refetch } = useQuery<{
    RankingListV2: {
      status: { success: boolean; name: string; detail: string }
      total: number
      pages: number
      Ranking
    }
  }>(RANKING_LIST, {
    variables: { RankingListInput: rankingListInput },
    errorPolicy: "all",
    skip: !rankingListInput,
  })

  return {
    data: data?.RankingListV2,
    loading,
    error,
    refetch,
  }
}
